import type { SearchLocation } from 'modules/search/types/SearchLocation';
import type { SearchType } from 'modules/search/types/SearchType';
import type { SavedSearchIndex } from 'modules/userDashboard/api/savedSearch/types/UserDashboardApiSavedSearch';

import { isLocationEmpty } from './sidefilters';

export const makeSavedSearchLocation = (searchLocation: SearchLocation) =>
  isLocationEmpty(searchLocation)
    ? { ...searchLocation, hasGeo: false }
    : { ...searchLocation, hasGeo: true };

export const filterToIndex = (t: SearchType): SavedSearchIndex => {
  // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
  switch (t) {
    case 'VOLOP':
      return 'ACTIONS';

    default:
      return 'MAIN';
  }
};
